// Create a new file: frontend/src/hooks/useAppRouter.ts
import { buildRoutes } from 'helpers/routeBuilder';
import { useMemo } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { generateRoutesWithPages } from 'routes';
import { useSite } from 'selectors/siteSelectors';

export const useAppRouter = (element: React.ReactNode) => {
  const { pages } = useSite();

  return useMemo(() => {
    const completeRoutes = generateRoutesWithPages(pages);
    const routes = [
      {
        path: '/',
        element,
        children: buildRoutes(completeRoutes),
      },
    ];
    return createBrowserRouter(routes);
  }, [pages, element]);
};
